import Dialog from "components/Dialog"
import React, { memo } from "react"
import { Divider } from "components/Divider/Divider"
import SupportSettingsModalTitle from "./SupportSettingsModalTitle"
import SupportSettingsFeatureSwitch from "./SupportSettingsFeatureSwitch"
import SupportSettingsPracticeSwitch from "./SupportSettingsPracticeSwitch"

type Props = {
  onClose: () => void
}

function SupportSettingsModal({ onClose }: Props): JSX.Element {
  return (
    <Dialog heading={<SupportSettingsModalTitle />} open={true} onClose={onClose} width="sm">
      <SupportSettingsPracticeSwitch />
      <Divider />
      <SupportSettingsFeatureSwitch />
    </Dialog>
  )
}

export default memo(SupportSettingsModal)
